//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import Widget from './components/Widget';
import Menu from './components/Menu';

export default {
    name: 'RecentDiscussions',
    components: {
		appWidget: Widget,
		appMenu: Menu
	},
    props: {
        type: String,
        data: Object
    }
}
